/* eslint no-console: "off", quotes: "off", no-mixed-operators: "off" */
import {mapState, mapMutations, mapActions} from 'vuex'
import {gameCategoryEnum, gameThemeEnum, preGameFailedReasonEnum} from '../../constants/game'

export const GameTypesEnums = {
  MUSIC: 'MUSIC',
  NO_CATEGORY: 'NO_CATEGORY',
  GEOGRAPHY: 'GEOGRAPHY',
  MOVIES: 'MOVIES',
  FOOD: 'FOOD',
  ARTS: 'ARTS',
  HISTORY: 'HISTORY',
  SPORTS: 'SPORTS',
  SCIENCE: 'SCIENCE',
  WORLD: 'WORLD',
  MATH: 'MATH',
  NATURE: 'NATURE',
  LANGUAGES: 'LANGUAGES',
  CHRISTMAS: 'CHRISTMAS',
  RAMADAN: 'RAMADAN',
  ISLAMIC: 'ISLAMIC',
  SUMMER: 'SUMMER',
  FOOTBALL: 'FOOTBALL',
  KNOW_YOUR_COUNTRY: 'KNOW_YOUR_COUNTRY',
};

export const GameModesEnums = {
  EASY: "EASY",
  HARD: "HARD",
  VERY_HARD: "VERY_HARD",
};

export const ParseResponseMixin = {
  methods: {
    parseServerResponse(responseBody) {
      let parsedResponse = null;
      try {
        console.log('Parsing server response...');
        parsedResponse = JSON.parse(responseBody);
      } catch (error) {
        console.error(`Failed to parse server response with the following error: ${error}`);
      }
      return parsedResponse;
    },
  },
};

export const preGameMixin = {
  computed: {
    ...mapState('common', [
      'userDetails'
    ]),
    ...mapState('profile', [
      'jwtInVuex'
    ])
  },
  methods: {
    ...mapActions('profile', [
      'checkCoreResponses',
      'getUserLoginDetails'
    ]),
    $_canUserPlayTheGame (gameType) {
      return this.checkCoreResponses().then(response => {
        if (
          (response === 'CORE_IS_DOWN') ||
          !Object.values({...gameThemeEnum, ...gameCategoryEnum}).includes(gameType)
        ) {
          return {canPlay: false, failedReason: preGameFailedReasonEnum.MAINTENANCE}
        } else if (this.userDetails.availableGames === 0) {
          return {canPlay: false, failedReason: preGameFailedReasonEnum.ZERO_BALANCE}
        }

        return {canPlay: true, failedReason: null}
      }).then(data => {
        if (!data.canPlay) {
          return data
        }

        return this.$axios({
          url: `api/randomMatchingForDistinguished?gameTheme=${gameType}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex
          }
        }).then(response => {
          const responseEnum = response.data && response.data.responseEnum

          if (['SERVER_ERROR', 'EVENT_LOCKED'].includes(responseEnum)) {
            return {canPlay: false, failedReason: preGameFailedReasonEnum.MAINTENANCE}
          } else if (responseEnum === 'NO_AVAILABLE_GAMES') {
            // if the user has no available games, we need to update the user's available games
            return this.getUserLoginDetails().then(() => {
              return {canPlay: false, failedReason: preGameFailedReasonEnum.ZERO_BALANCE}
            })
          }

          return {canPlay: true, failedReason: null}
        })
      }).catch(error => console.error(error))
    }
  }
}

// game mixin object (shared between ResumingGame and Game components)
export const GameMixin = {
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (!this.stompClient.connected && !this.isResume) this.stompFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      playerAnswered: false,
      bothPlayersAnswered: false,
    };
  },
  methods: {
    ...mapMutations('game', [
      'setUserLeveledUp',
      'setPlayersPostGameData',
      'updatePrizePostGameData',
    ]),
    ...mapMutations('common', [
      'storeUserLevel',
      'storeUserAvailableCoins',
    ]),
    setPrizePostGameData(responseData) {
      this.updatePrizePostGameData({
        winDTO: responseData.prizeWonDTO,
        lostDTOs: responseData.prizesNotWonDTO,
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'playersDetails',
      'miniGames',
      'currentMiniGameRound',
    ]),
  },
};

// game mixin object 2 (shared between all game components and is used for flow control,
// when we press the back or forward browser buttons or refresh the page)
export const GameMixin2 = {
  data() {
    return {
      normalTransition: false,
    };
  },
  methods: {
    ...mapMutations('game', [
      'setTransitionOnlyForSearchingToOpponent',
      'storeBrainiacGameData',
      'setMiniGameType',
      'setCurrentMiniGameRound',
      'setPlayersPostGameData',
      'setMiniGames',
      'setGameID',
      'setTotalUserPoints',
      'setPointsPerMiniGame',
      'setSpecificMiniGameFields',
    ]),
    changeBrainiacMiniGameType(value) {
      if (value) {
        this.setMiniGameType(value);
      } else {
        this.setMiniGameType('MEMORY_LIST_QUIZ');
      }
    },
    storeSwipoGameData(correctAnswer = false) {
      // below we created a new mutation to change miniGames state, due to an vuex error (Do not mutate vuex store state outside mutation handlers)
      this.setSpecificMiniGameFields({ index: this.currentMiniGameRound, correct: correctAnswer });
      this.setCurrentMiniGameRound(this.currentMiniGameRound + 1);
      this.setMiniGameType(this.miniGames[this.currentMiniGameRound]);
      this.defileUserPoints();
    },
    defineNextRoute() {
      this.setGameID(this.gameID);
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      this.$router.replace('/game');
    },
    defileUserPoints() {
      this.setTotalUserPoints(this.totalUserPoints +
          this.pointsPerMiniGame * (this.miniGames.slice(this.currentMiniGameRound - 1, this.currentMiniGameRound)
            .filter(miniGame => miniGame.answered && miniGame.correct).length));
    },
    getNumberOfRowsBasedOnLengthOfMatrix(length) {
      return (length === 56 ? 8 : 7);
    },
    getNumberOfColumnsBasedOnLengthOfMatrix(length) {
      // eslint-disable-next-line
      return (length === 56 ? 8 : length === 49 ? 7 : 5);
    },
    storeSwipoPostGameData(responseData) {
      console.log(responseData);
      this.setPlayersPostGameData({
        gamesPlayed: responseData.listOfPlayedMiniGames.length,
        gamesWon: responseData.listOfWonMiniGames.length,
        iqPoints: !responseData.userGameDetailsDTO.iq ? 0 : responseData.userGameDetailsDTO.iq,
        bonusPoints: !responseData.userGameDetailsDTO.postgamePointsTotal ? 0 : responseData.userGameDetailsDTO.postgamePointsTotal,
        pointsEarned: !this.pointsPerMiniGame ? 0 : this.pointsPerMiniGame * responseData.listOfWonMiniGames.length,
      });
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log('==> inside component\'s beforeRouteEnter:');
  //   console.log(`from.path: ${from.path}`);
  //   console.log(`to.path: ${to.path}`);
  //   // the page have must been refreshed, redirect to home page
  //   if (from.path === '/') {
  //     next({ path: '/home' });
  //   }
  //   next();
  // },
  // beforeRouteLeave(to, from, next) {
  //   console.log('==> inside component\'s beforeRouteLeave:');
  //   console.log(`from.path: ${from.path}`);
  //   console.log(`to.path: ${to.path}`);
  //   console.log('this.normalTransition:');
  //   console.log(this.normalTransition);
  //   if (this.transitionOnlyForSearchingToOpponent && (from.path === '/searchingOpponent' && to.path === '/opponentFound')) {
  //     console.log('User tries again for the same Game to play a game, so navigate him to Opponent Found and not HOME');
  //     this.normalTransition = true;
  //     this.setTransitionOnlyForSearchingToOpponent(false);
  //     next();
  //   }
  //   if (!this.normalTransition) {
  //     this.normalTransition = true;
  //     console.log('going to home');
  //     next({ path: '/home' });
  //   }
  //   next();
  // },
  computed: {
    ...mapState('game', [
      'gameID',
      'transitionOnlyForSearchingToOpponent',
      'miniGames',
      'playersDetails',
      'currentMiniGameRound',
      'totalUserPoints',
      'pointsPerMiniGame',
    ]),
  },
};

export const GameMixin3 = {
  beforeDestroy() {
    console.log(`in ${this.$options.name} beforeDestroy hook`);
    console.log('this.subscription', this.subscription);
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channel
    this.subscription.unsubscribe();
    if (this.timer !== undefined || this.timer !== null) {
      clearInterval(this.timer);
      this.stopTimer();
    }
  },
};

export const GameMixin4 = {
  data() {
    return {
      normalTransition: false,
    };
  },
  methods: {
    ...mapMutations('game', [
      'updateUnauthorizedWinnerInfo',
    ]),
    saveUnauthorizedMsisdnAndPrizeIdToCallLSC() {
      this.updateUnauthorizedWinnerInfo();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.normalTransition) {
      console.log('going to visitor');
      this.normalTransition = true;
      this.subscription.unsubscribe();
      this.stompClient.disconnect();
      next({ path: '/' });
    }
    next();
  },
};



// WEBPACK FOOTER //
// ./src/common/mixins/game.js